var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccStageUpdate = function SvgAccStageUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_acc-stage-update",
    transform: "translate(-318 -184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 16,
    height: 16,
    transform: "translate(318 184)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "move_up_FILL0_wght300_GRAD-25_opsz20",
    d: "M79.457-715.857a4.827,4.827,0,0,1-3.325-1.25,4.015,4.015,0,0,1-1.4-3.125,4.037,4.037,0,0,1,1.592-3.306,5.342,5.342,0,0,1,3.7-1.177h.355l-.894-.879a.435.435,0,0,1-.158-.334.5.5,0,0,1,.163-.346.452.452,0,0,1,.332-.152.478.478,0,0,1,.33.158l1.643,1.643a.555.555,0,0,1,.184.412.578.578,0,0,1-.184.419l-1.651,1.631a.45.45,0,0,1-.332.154.5.5,0,0,1-.346-.154.428.428,0,0,1-.142-.324.516.516,0,0,1,.172-.334l.979-.979H80.1a4.388,4.388,0,0,0-3.084.894,3.207,3.207,0,0,0-1.342,2.676,3.112,3.112,0,0,0,1.124,2.455,3.925,3.925,0,0,0,2.658.974H81.7a.459.459,0,0,1,.335.138.447.447,0,0,1,.139.329.464.464,0,0,1-.139.336.452.452,0,0,1-.335.142Zm5.041-6.106a.574.574,0,0,1-.424-.172.573.573,0,0,1-.171-.42v-2.951a.576.576,0,0,1,.172-.422.57.57,0,0,1,.42-.173h4.642a.573.573,0,0,1,.422.174.571.571,0,0,1,.173.418v2.951a.571.571,0,0,1-.174.424.574.574,0,0,1-.418.171Zm0,6.106a.571.571,0,0,1-.424-.174.579.579,0,0,1-.171-.422V-719.4a.58.58,0,0,1,.172-.425.569.569,0,0,1,.42-.173h4.642a.573.573,0,0,1,.422.174.576.576,0,0,1,.173.422v2.948a.577.577,0,0,1-.174.425.571.571,0,0,1-.418.173Zm.35-.945h3.939v-2.252H84.848Z",
    transform: "translate(243.768 913.142)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccStageUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accStageUpdate.870110d9.svg";
export { ForwardRef as ReactComponent };